<template>
  <Catalog
    title="Вакансия"
    name-label="Название вакансии"
    submit-error="Укажите название вакансии."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="exactId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "Vacancy",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    exactId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getVacancyById(id);
    },
    async putData(data) {
      return await this.putVacancy(data)
    },
    async postData(data) {
      return await this.postVacancy(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/Vacancy.vue